import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faToolbox
} from "@fortawesome/free-solid-svg-icons";

import './ProcedimientoInfo.css';

const ProcedimientoInfo = ({procedimiento, handleLookInfo}) => {
    return <div className="procInfoContainer">
        <div className='label-profile-icon'><FontAwesomeIcon icon={faToolbox}/></div>
            <div className='container-profile'>
                <div className='label-profile'>Procedimiento: <div className='label-profile-data'>{procedimiento.name}</div></div>
                <div className='label-profile'>ID: <div className='label-profile-data'>{procedimiento._id}</div></div>
                <div className='label-profile'>Codigo: <div className='label-profile-data'>{procedimiento.codProc}</div></div>
            </div>
            <div className='btn-profile-container'><button className='btn-profile' onClick={()=>handleLookInfo(undefined)}>Aceptar</button></div>
    </div>
}

export default ProcedimientoInfo;